// TKA Sucursales Locator JS
(function() {
  function initSucursalesLocator(sectionContainer) {
    if (!sectionContainer) return;
    if (sectionContainer.dataset.initialized === 'true') return;
    sectionContainer.dataset.initialized = 'true';

    var regionSelect = sectionContainer.querySelector('[data-filter="region"]');
    var ciudadSelect = sectionContainer.querySelector('[data-filter="ciudad"]');
    var resetBtn = sectionContainer.querySelector('[data-action="reset-filters"]');
    var countEl = sectionContainer.querySelector('[data-element="filter-count"]');
    var storeCards = Array.from(sectionContainer.querySelectorAll('.tka-store-card'));
    var mapWrapper = sectionContainer.querySelector('[data-element="iframe-target"]');
    var mapOverlay = sectionContainer.querySelector('[data-element="map-overlay"]');
    var noStoresEl = sectionContainer.querySelector('[data-element="no-stores"]');

    if (!storeCards.length || !mapWrapper) return;

    var DAYS_MAP = {
      0: ['domingo', 'dom'],
      1: ['lunes', 'lun'],
      2: ['martes', 'mar'],
      3: ['miercoles', 'miércoles', 'mie', 'mié'],
      4: ['jueves', 'jue'],
      5: ['viernes', 'vie'],
      6: ['sabado', 'sábado', 'sab', 'sáb']
    };

    var todayIndex = new Date().getDay(); // 0 = Domingo, 1 = Lunes, etc.

    function parseSchedule(infoRaw) {
      if (!infoRaw) return [];
      var lines = infoRaw.split(/\r?\n/).map(function(l) { return l.trim(); }).filter(Boolean);
      var scheduleItems = [];

      lines.forEach(function(line) {
        var dayName = '';
        var hours = '';

        if (line.indexOf(':') > -1) {
          var parts = line.split(':');
          dayName = parts[0].trim();
          hours = parts.slice(1).join(':').trim();
        } else if (line.indexOf('-') > -1) {
          var partsDash = line.split('-');
          dayName = partsDash[0].trim();
          hours = partsDash.slice(1).join('-').trim();
        } else {
          dayName = line;
          hours = '';
        }

        var normDay = dayName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        var matchedDayIdx = -1;

        for (var idx in DAYS_MAP) {
          var aliases = DAYS_MAP[idx];
          for (var a = 0; a < aliases.length; a++) {
            var normAlias = aliases[a].normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if (normDay.indexOf(normAlias) === 0) {
              matchedDayIdx = parseInt(idx, 10);
              break;
            }
          }
          if (matchedDayIdx !== -1) break;
        }

        scheduleItems.push({
          originalLine: line,
          dayName: dayName,
          hours: hours,
          dayIndex: matchedDayIdx,
          isToday: (matchedDayIdx === todayIndex)
        });
      });

      return scheduleItems;
    }

    var storeDataList = [];
    var regionCityMap = {};
    var allRegions = [];
    var allCities = [];

    storeCards.forEach(function(card, index) {
      var title = (card.getAttribute('data-title') || '').trim();
      var region = (card.getAttribute('data-region') || '').trim();
      var city = (card.getAttribute('data-city') || '').trim();
      var info = card.getAttribute('data-info') || '';

      if (region) {
        var regionFound = false;
        for (var r = 0; r < allRegions.length; r++) {
          if (allRegions[r].toLowerCase() === region.toLowerCase()) {
            regionFound = true;
            region = allRegions[r]; // Mantener capitalización consistente
            break;
          }
        }
        if (!regionFound) {
          allRegions.push(region);
        }

        if (!regionCityMap[region]) {
          regionCityMap[region] = [];
        }

        if (city) {
          var cityInRegionFound = false;
          for (var c = 0; c < regionCityMap[region].length; c++) {
            if (regionCityMap[region][c].toLowerCase() === city.toLowerCase()) {
              cityInRegionFound = true;
              city = regionCityMap[region][c];
              break;
            }
          }
          if (!cityInRegionFound) {
            regionCityMap[region].push(city);
          }
        }
      }

      if (city) {
        var cityFound = false;
        for (var ct = 0; ct < allCities.length; ct++) {
          if (allCities[ct].toLowerCase() === city.toLowerCase()) {
            cityFound = true;
            break;
          }
        }
        if (!cityFound) {
          allCities.push(city);
        }
      }

      var scheduleList = parseSchedule(info);
      var todayItem = null;
      for (var s = 0; s < scheduleList.length; s++) {
        if (scheduleList[s].isToday) {
          todayItem = scheduleList[s];
          break;
        }
      }

      var todayHoursEl = card.querySelector('.js-today-hours');
      var scheduleGridEl = card.querySelector('.js-schedule-grid');

      if (todayHoursEl) {
        if (todayItem && todayItem.hours) {
          todayHoursEl.textContent = todayItem.hours;
        } else if (todayItem) {
          todayHoursEl.textContent = todayItem.dayName;
        } else if (scheduleList.length > 0 && scheduleList[0].hours) {
          todayHoursEl.textContent = scheduleList[0].hours;
        } else {
          todayHoursEl.textContent = 'Ver detalle';
        }
      }

      if (scheduleGridEl && scheduleList.length > 0) {
        scheduleGridEl.innerHTML = '';
        scheduleList.forEach(function(item) {
          var row = document.createElement('div');
          row.className = 'tka-schedule-row' + (item.isToday ? ' is-today' : '');

          var dayCol = document.createElement('span');
          dayCol.className = 'tka-schedule-row-day';
          dayCol.textContent = item.dayName + (item.hours ? ':' : '');

          var timeCol = document.createElement('span');
          timeCol.className = 'tka-schedule-row-time';
          timeCol.textContent = item.hours;

          row.appendChild(dayCol);
          row.appendChild(timeCol);
          scheduleGridEl.appendChild(row);
        });
      }

      var accordionHeader = card.querySelector('.tka-schedule-header');
      var accordion = card.querySelector('.tka-schedule-accordion');
      if (accordionHeader && accordion) {
        accordionHeader.onclick = function(e) {
          e.stopPropagation();
          accordion.classList.toggle('is-open');
        };
      }

      storeDataList.push({
        element: card,
        index: index,
        title: title,
        region: region,
        city: city,
        template: card.querySelector('.tka-store-iframe-template')
      });

      card.onclick = function() {
        setActiveStore(index);
      };
    });

    // Resetear y poblar dropdown de Regiones
    if (regionSelect) {
      regionSelect.innerHTML = '<option value="all">Todas las regiones</option>';
      allRegions.sort(function(a, b) { return a.localeCompare(b, 'es'); });
      allRegions.forEach(function(reg) {
        var opt = document.createElement('option');
        opt.value = reg;
        opt.textContent = reg;
        regionSelect.appendChild(opt);
      });
    }

    function updateCityDropdown(selectedRegion) {
      if (!ciudadSelect) return;
      var currentCity = ciudadSelect.value;
      ciudadSelect.innerHTML = '<option value="all">Todas las ciudades</option>';

      var citiesToShow = [];
      if (selectedRegion && selectedRegion !== 'all' && regionCityMap[selectedRegion]) {
        citiesToShow = regionCityMap[selectedRegion].slice();
      } else {
        citiesToShow = allCities.slice();
      }

      citiesToShow.sort(function(a, b) { return a.localeCompare(b, 'es'); });
      citiesToShow.forEach(function(city) {
        var opt = document.createElement('option');
        opt.value = city;
        opt.textContent = city;
        ciudadSelect.appendChild(opt);
      });

      if (citiesToShow.indexOf(currentCity) > -1) {
        ciudadSelect.value = currentCity;
      } else {
        ciudadSelect.value = 'all';
      }
    }

    updateCityDropdown('all');

    function setActiveStore(targetIndex) {
      var store = storeDataList[targetIndex];
      if (!store) return;

      storeCards.forEach(function(c, idx) {
        if (idx === targetIndex) {
          c.classList.add('is-active');
          try {
            c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch(e) {
            c.scrollIntoView();
          }
        } else {
          c.classList.remove('is-active');
        }
      });

      if (mapWrapper && store.template) {
        var iframeContent = store.template.innerHTML.trim();
        if (iframeContent.indexOf('<iframe') > -1) {
          iframeContent = iframeContent
            .replace(/width="[^"]*"/gi, 'width="100%"')
            .replace(/height="[^"]*"/gi, 'height="100%"')
            .replace(/style="[^"]*"/gi, 'style="border:0; width:100%; height:100%; min-height:100%;"');
          mapWrapper.innerHTML = iframeContent;
        } else if (iframeContent.indexOf('http') === 0) {
          mapWrapper.innerHTML = '<iframe src="' + iframeContent + '" width="100%" height="100%" style="border:0; min-height:100%;" allowfullscreen="" loading="lazy"></iframe>';
        } else {
          mapWrapper.innerHTML = iframeContent;
        }
      }

      if (mapOverlay) {
        mapOverlay.textContent = store.title;
      }
    }

    if (storeDataList.length > 0) {
      setActiveStore(0);
    }

    function applyFilter() {
      var selectedRegion = regionSelect ? regionSelect.value : 'all';
      var selectedCity = ciudadSelect ? ciudadSelect.value : 'all';

      var visibleCount = 0;
      var firstVisibleIdx = -1;
      var currentActiveStillVisible = false;
      var currentActiveCard = sectionContainer.querySelector('.tka-store-card.is-active');
      var currentActiveIdx = currentActiveCard ? parseInt(currentActiveCard.getAttribute('data-index'), 10) : -1;

      storeDataList.forEach(function(store) {
        var matchRegion = (selectedRegion === 'all' || store.region.toLowerCase() === selectedRegion.toLowerCase());
        var matchCity = (selectedCity === 'all' || store.city.toLowerCase() === selectedCity.toLowerCase());

        if (matchRegion && matchCity) {
          store.element.style.display = '';
          visibleCount++;
          if (firstVisibleIdx === -1) {
            firstVisibleIdx = store.index;
          }
          if (store.index === currentActiveIdx) {
            currentActiveStillVisible = true;
          }
        } else {
          store.element.style.display = 'none';
        }
      });

      if (countEl) {
        countEl.textContent = visibleCount + (visibleCount === 1 ? ' sucursal' : ' sucursales');
      }

      if (resetBtn) {
        if (selectedRegion !== 'all' || selectedCity !== 'all') {
          resetBtn.style.display = 'inline-flex';
        } else {
          resetBtn.style.display = 'none';
        }
      }

      if (noStoresEl) {
        noStoresEl.style.display = (visibleCount === 0) ? 'block' : 'none';
      }

      if (visibleCount > 0) {
        if (!currentActiveStillVisible && firstVisibleIdx !== -1) {
          setActiveStore(firstVisibleIdx);
        }
      } else {
        if (mapWrapper) {
          mapWrapper.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#9ca3af;font-size:14px;">No hay mapa disponible</div>';
        }
      }
    }

    if (regionSelect) {
      regionSelect.onchange = function() {
        updateCityDropdown(this.value);
        applyFilter();
      };
    }

    if (ciudadSelect) {
      ciudadSelect.onchange = function() {
        applyFilter();
      };
    }

    if (resetBtn) {
      resetBtn.onclick = function() {
        if (regionSelect) regionSelect.value = 'all';
        updateCityDropdown('all');
        if (ciudadSelect) ciudadSelect.value = 'all';
        applyFilter();
      };
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.section-tka-sucursales');
    sections.forEach(function(sec) {
      initSucursalesLocator(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var sectionTarget = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (sectionTarget) {
      var container = sectionTarget.querySelector('.section-tka-sucursales');
      if (container) {
        container.dataset.initialized = 'false';
        initSucursalesLocator(container);
      }
    }
  });
})();
